import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { Http } from '@angular/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { debounceTime, map, take, retry } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';

@Injectable({ "providedIn": "root" })
export class ManikEntityService {
  myAppUrl: any = location.origin + "/";
  DomainName: string;
 
  private DataPassed = new BehaviorSubject(null);
  Data = this.DataPassed.asObservable();
  constructor(private _httpClient: HttpClient, @Inject(DOCUMENT) public document: any) {
    //this.myAppUrl = this.document.baseURI;
    this.DomainName = location.hostname.replace("www.", "");    
   
  }

  setData(data: any) {
    this.DataPassed.next(data);
  }

  manikEntityConnect(route: string, body: any, header: any) {
    return this._httpClient.post<any>(this.myAppUrl + route, body, { headers: header })
      .pipe(map(value => {
        return value;
      }), take(1), retry(3));
  }

  manikEntityConnect2(route: string, body: string, header: any) {
    return this._httpClient.post<any>( route, body, { headers: header })
      .pipe(map(value => value), take(2), retry(3));
  }
  manikWebAPIConnectHttp(url: string, body: any, header: any) {
    return this._httpClient.post(url, body, header).pipe(map(value => {
      let response: any = value;
      return value
    }), take(1));
  }


  manikWebAPIConnectGeneric(url: string, body: string, header: HttpHeaders, method: string) {
    switch (method) {
      case 'GET':
        return this._httpClient.get<any>(url, { headers: header }).pipe(map(value => value), take(1), retry(2));
      case 'POST':
        return this._httpClient.post<any>(url, body, { headers: header }).pipe(map(value => value), take(1), retry(2));
    }
  }

  manikWebAPIConnect(url: string, body: any, header: any) {
    return this._httpClient.post(url, body, { headers: header }).pipe(map(value => value), take(1));
  }

  manikFileUpload(uploadUrl: string, frmData: any, header: any) {
    return this._httpClient.post<any>(uploadUrl, frmData, { headers: header });
  }

  manikAutoComplete(route: string, body: any, header: any) {
    return this._httpClient.post<any>(this.myAppUrl + route, body, { headers: header })
      .pipe(debounceTime(500), map(data => { return data; }), take(1));
  }
  manikAutoComplete2(route: string, body: any, header: any) {
    return this._httpClient.post<any>(route, body, { headers: header })
      .pipe(debounceTime(500), map(data => { return data; }), take(1));
  }

  errorHandler(error: Response) {
    return Observable.throw(error);
  }
}
